module.exports = __webpack_public_path__ + "media/src/images/icons/credit_cards/visa-b39b39d50fc0a8f9d0386cff7108534a.png";